export const tileActionClass =
  "shrink-0 bg-lagoon-300 rounded p-3 flex items-center hover:bg-primary hover:text-secondary after:absolute after:inset-0 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary in-inverted:focus-visible:outline-white";
